import React from 'react'
import { useStyles } from './styles'

interface PlayerWrapperProps {
    children: React.ReactNode
    stateId: string
}

const PlayerWrapper: React.FC<PlayerWrapperProps> = ({ children, stateId }) => {
    const classes = useStyles()
    return (
        <div className={classes.playerWrapper} data-testid={`${stateId}_wrapper`}>
            {children}
        </div>
    )
}

export default React.memo(PlayerWrapper)
